import { NativeActionNames } from '@wix/editor-platform-host-integration-apis';
import type { Action, DashboardAction } from '@wix/component-protocol/schema';
import {
  CustomizedNativeManifestAction,
  CustomizedDashboardManifestAction,
  EditActionsDictionary,
} from '../types';
import { platformNativeActions } from './platformNativeActions';
import { isCustomizedNativeManifestAction } from '../utils';

export type CustomizedManifestAction =
  | CustomizedNativeManifestAction
  | CustomizedDashboardManifestAction;

export type GroupedNativeActions = {
  nativeActions: EditActionsDictionary<Action | DashboardAction>;
  platformNativeActions: EditActionsDictionary<Action | DashboardAction>;
  customizedNativeActions: EditActionsDictionary<CustomizedManifestAction>;
};

export function groupNativeActions(
  nativeActions: Record<string, Action>,
): GroupedNativeActions {
  return (
    Object.entries(nativeActions) as [
      NativeActionNames,
      Action | DashboardAction,
    ][]
  ).reduce<GroupedNativeActions>(
    (acc: GroupedNativeActions, [actionName, action]) => {
      if (actionName in platformNativeActions) {
        acc.platformNativeActions[actionName] = action;
        return acc;
      } else if (isCustomizedNativeManifestAction(action)) {
        acc.customizedNativeActions[actionName] = action;
      } else {
        acc.nativeActions[actionName] = action;
      }
      return acc;
    },
    {
      nativeActions: {},
      platformNativeActions: {},
      customizedNativeActions: {},
    },
  );
}
